
import { Component, Vue, Prop } from 'vue-property-decorator';
import index from '@/plugins/algoliasearch';
import { db } from '@/plugins/firebase';

@Component({
  props: ['item'],
})
export default class SearchResult extends Vue {
  @Prop() item: any;
  entry: any = {};

  get page() {
    return parseInt(this.item.id.split('-')[1]) + 1;
  }
}
